export default __webpack_public_path__ + "static/media/not-available.93cdcf67.png";